import React from 'react'
import messages from './messages'
import { FormattedMessage } from 'react-intl'

type Props = {
  text?: string
  light: boolean
}

const Divider = ({ text, light = false }: Props) => {
  return (
    <span className={light ? 'c-divider c-divider--light' : 'c-divider'}>
      <span className="sr-only">…</span>
      <span className="c-divider__inner">
        {text && <span>{text}</span>}
        {!text && <FormattedMessage {...messages.or} />}
      </span>
      <span className="sr-only">…</span>
    </span>
  )
}

export default Divider
